














import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    pErrors: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  computed: {
    hasPError() {
      return this.pErrors.length > 0;
    },
  },
});
